import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

export default function setDepoimentos() {
  const depoimentos = document.querySelectorAll("[data-depoimentos]");

  depoimentos.forEach((section) => {
    const carousel = section.querySelector(".swiper");
    const pagination = section.querySelector(".swiper-pagination");
    const next = section.querySelector(".swiper-button-next");
    const prev = section.querySelector(".swiper-button-prev");

    const newFullbanner = new Swiper(carousel, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 16,
      watchOverflow: true,
      speed: 1600,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
        disabledClass: "-disabled",
      },
      pagination: {
        el: pagination,
        type: "bullets",
        clickable: true,
      },
    });

    //Autoplay condicional
    newFullbanner.autoplay.stop();

    const eventType = window.mobile ? "scroll" : "mousemove";
    window.addEventListener(eventType, newFullbanner.autoplay.start, {
      once: true,
    });
  });
}
